import { DataPointPeriodicity } from '../../schemas/CompanyPeriodRequest.schema';
import { KpiPeriodRequestDocument } from '../../schemas/KpiPeriodRequestDocument.schema';
import { MaggieHttp } from '../MaggieHttp';

interface KpiPeriodRequestDocumentsResponse {
  documents: KpiPeriodRequestDocument[];
  total: number;
}

export async function getKpiPeriodRequestDocuments(companyId: number): Promise<KpiPeriodRequestDocument[]> {
  const { data } = await MaggieHttp.maggie.get<KpiPeriodRequestDocumentsResponse>(
    `/kpiDocs/company/${companyId}`
  );
  return data.documents.filter((doc) => Boolean(doc.starbreakerDocumentId));
}

interface KpiRequestDocumentDownloadResponse {
  downloadUrl: string;
}

export async function getKpiRequestDocumentDownloadUrl(
  starbreakerDocumentId: string,
  companyId: number
): Promise<KpiRequestDocumentDownloadResponse> {
  const { data } = await MaggieHttp.maggie.get<KpiRequestDocumentDownloadResponse>(
    `/data-requests/documents/${starbreakerDocumentId}/download-url`,
    { params: { companyId } }
  );

  return data;
}

export type KpiDocsExportStatus = 'pending' | 'running' | 'complete' | 'empty' | 'failed';

export interface KpiDocsExportParams {
  companyIds?: number[];
  dateFrom?: string;
  dateTo?: string;
  periodicity?: DataPointPeriodicity;
}

export interface KpiDocsExportJob {
  jobId: string;
  status: KpiDocsExportStatus;
  downloadUrl?: string | null;
  expiresAt?: string | null;
  errorMessage?: string | null;
}

export async function initiateKpiDocsExport(params?: KpiDocsExportParams): Promise<KpiDocsExportJob> {
  const { data } = await MaggieHttp.maggie.post<KpiDocsExportParams, KpiDocsExportJob>(
    '/kpiDocs/export',
    params ?? {}
  );
  return data;
}

export async function getKpiDocsExportStatus(jobId: string): Promise<KpiDocsExportJob> {
  const { data } = await MaggieHttp.maggie.get<KpiDocsExportJob>(`/kpiDocs/export/${jobId}`);
  return data;
}
